// extracted by mini-css-extract-plugin
export default {"ppPage":"PrivacyPolicy_ppPage__O01-7","pageContainer":"PrivacyPolicy_pageContainer__QPF+-","section":"PrivacyPolicy_section__Jv4Me"};